(function ($) {
    var $body = $('body');

    var footerMask = function () {
        $('.footer-mask').css('height', $('.footer').outerHeight());
    };

    var footerTogglemobileMenu = function () {
        $('.columns-personal, .columns-work, .go-ft-columns').on('click', '.widget-title', function (e) {
            e.preventDefault();
            if (window.innerWidth < 768) {
                var $title = $(this),
                    $menu = $title.siblings('div[class*="menu-"]');

                if ($title.is('.open')) {
                    $title.removeClass('open');
                    $menu.slideUp();
                } else {
                    $title.addClass('open');
                    $menu.slideDown();
                }
            }
        })
    };

    function initLightBox() {
        $('.image-dialog').on('click', function (e) {
            e.preventDefault();
        });
        //if you want run simpleLightbox on <img> please remember change .image-dialog from <div .image-dialog> to <a .image-dialog href>
        // $('.image-dialog').simpleLightbox();
    }

    function postsListToggle() {
        $body.on('click', 'a.toggle-post-desc', function (e) {
            e.preventDefault();
            var $button = $(this),
                $parent = $button.closest('.sp-list-item');

            if ($button.is('.toggle')) {
                $button.removeClass('toggle');
                $button.text($button.attr('data-close'));
                $parent.find('.short-desc').removeClass('hidden');
                $parent.find('.short-full').addClass('hidden');
            } else {
                $button.addClass('toggle');
                $button.text($button.attr('data-open'));
                $parent.find('.short-desc').addClass('hidden');
                $parent.find('.short-full').removeClass('hidden');
            }
        })
    }

    function lineDraw() {
        $('.line-animated').css('opacity', 1);
        var path = document.querySelector('.line-animated path');
        var length = path.getTotalLength();
        path.style.transition = path.style.WebkitTransition = 'none';
        path.style.strokeDasharray = length + ' ' + length;
        path.style.strokeDashoffset = length;
        path.getBoundingClientRect();
        path.style.transition = path.style.WebkitTransition = 'stroke-dashoffset 5s ease-in-out';
        path.style.strokeDashoffset = '0';
    };
    /** Header menu */
    function headerMenu() {
        var service = {
            parseParams: function (params) {
                return (typeof params == "string" ? JSON.parse(params) : params);
            },
            show: function (params, onlyWrapper) {
                if (onlyWrapper) {
                    $body.addClass('visible-modules-wrapper');
                } else {
                    $body.removeClassWild("*-module-service");
                    $body.addClass('visible-modules-wrapper visible-' + params.module + '-module-service');
                }
                $('#primary-menu-toggle').addClass('open');
                    if ( $(window).width() < 767 ) {
                        hideBanner();
                    }
            },
            hide: function () {
                $body.removeClass('visible-modules-wrapper');
                $body.removeClass('visible-menu');
                $('#primary-menu-toggle').removeClass('open');
                setTimeout(function () {
                    $body.removeClassWild("*-module-service");
                }, 400);
                    if ( $(window).width() < 767 ) {
                        showBanner();
                    }
            },
            back: function (params) {
                if (typeof params.backTo != "undefined" && $body.find('.menu-module-' + params.backTo).length > 0) {
                    service.show({module: params.backTo});
                } else {
                    $body.removeClass('visible-' + params.module + '-module-service');
                }
            },
            trigger: function (params) {
                if ($body.is('.visible-' + params.module + '-module-service')) {
                    service.hide();
                    if ( $(window).width() < 767 ) {
                        showBanner();
                    }
                } else {
                    service.show(params);
                    if ( $(window).width() < 767 ) {
                        hideBanner();
                    }
                }
            }
        };
        /** Cloning sub menus for desktop */
        $body.find('#primary-menu li').hover(function () {
            service.hide();
        });
        $body.find('#primary-menu .menu-item-21').append(
            '<div class="menu-modules-wrapper-hover">' +
            '<div class="menu-module-item menu-module-menu_personal">' +
            $('.menu-module-menu_personal').clone().html() +
            '</div>' +
            '</div>'
        );
        $body.find('#primary-menu .menu-item-22').append(
            '<div class="menu-modules-wrapper-hover">' +
            '<div class="menu-module-item menu-module-menu_work">' +
            $('.menu-module-menu_work').clone().html() +
            '</div>' +
            '</div>'
        );

        /** Language dropdown position */
        function lgPosition() {
            if( $body.find('.h-lang') && $body.find('.h-lang').offset()!==undefined ){
                var left = $body.find('.h-lang').offset().left;
                $body.find('.menu-module-language').css('left', left);
            }
        }

        lgPosition();
        $(window).on('resize', lgPosition);

        /** Menu click actions */
        $body.on('click ', '[data-menu-click]', function (e) {
            e.preventDefault();
            var $this = $(this),
                options = service.parseParams($this.attr('data-menu-click'));

            switch (options.action) {
                case 'show':
                    service.show(options);
                    break;
                case 'hide':
                    service.hide(options);
                    break;
                case 'back':
                    service.back(options);
                    break;
                default:
                    service.trigger(options);
            }
        });

        $body.find('[data-menu-hover]').on('mousemove', function (e) {
            e.preventDefault();
            var $this = $(this),
                options = service.parseParams($this.attr('data-menu-hover'));

            switch (options.action) {
                case 'show':
                    service.show(options);
                    break;
                case 'hide':
                    service.hide(options);
                    break;
                case 'back':
                    service.back(options);
                    break;
                default:
                    service.trigger(options);
            }
        });

        $('.menu-module-get_started').on('mouseleave', function(e) {
           if($body.is('.visible-get_started-module-service') && $(window).width() > 767){
                service.hide({});
            }
        });

        /** Mobile menu collapse */
        $body.on('click', '.mm-menu-title', function (e) {
            e.preventDefault();
            var $this = $(this),
                $parent = $this.closest('.mm-menu-box'),
                $submenu = $parent.find('.mm-menu-items');

            if ($parent.is('.collapsed')){
                $parent.removeClass('collapsed');
                $submenu.slideUp();
            } else {
                $parent.addClass('collapsed');
                $submenu.slideDown();
            }
        });

        /** Click outside element */
        $(document).click(function (event) {
            if (
                $(window).width() > 767 &&
                !$(event.target).is('[data-menu-click]') &&
                !$(event.target).closest('[data-menu-click]').length &&
                !$(event.target).is('.menu-modules-item') &&
                !$(event.target).closest('.menu-module-item').length &&
                !$(event.target).is('.btn-hamburger') &&
                !$(event.target).closest('.btn-hamburger').length
            ) {
                service.hide();
            }
        });
        
        var toolbar_height = $('.header-container').height() - $(window).height();
        var lastScrollTop;
        var mobile_toolbar = true;
        $body.on('click', '#primary-menu-toggle', function (e) {
            e.preventDefault();
            var $this = $(this);
            
            if ($this.is('.open')) {
                $this.removeClass('open');
                service.hide({});
                slideBanner();
            } else {
                $this.addClass('open');
                $body.addClass('visible-menu');
                service.show({}, true);
                hideBanner();
                
                if(mobile_toolbar){
                    $('.mm-contact-support').css('bottom', toolbar_height+'px');
                    $('.mm-contact-sales').css('bottom', toolbar_height+'px');
                }
                else{
                    $('.mm-contact-support').css('bottom', '0');
                    $('.mm-contact-sales').css('bottom', '0');
                }
            }
        });
        $( ".has-hover-card" ).hover(
            function() {
                $(this).find( '.hover-card' ).fadeIn('fast');
            }, function() {
                $(this).find( '.hover-card' ).fadeOut('fast');
            }
        );
        
        $( window ).resize(function() {
            var st = $(this).scrollTop();
            if (st > lastScrollTop){
                /* downscroll code */
                if(mobile_toolbar){
                    $('.mm-contact-support').css('bottom', '0');
                    $('.mm-contact-sales').css('bottom', '0');
                    mobile_toolbar = false;
                }
                else{
                    $('.mm-contact-support').css('bottom', toolbar_height+'px');
                    $('.mm-contact-sales').css('bottom', toolbar_height+'px');
                    mobile_toolbar = true;
                }
            } else {
                /* upscroll code */
                if(mobile_toolbar){
                    $('.mm-contact-support').css('bottom', '0');
                    $('.mm-contact-sales').css('bottom', '0');
                    mobile_toolbar = false;
                }
                else{
                    $('.mm-contact-support').css('bottom', toolbar_height+'px');
                    $('.mm-contact-sales').css('bottom', toolbar_height+'px');
                    mobile_toolbar = true;
                }
            }
            lastScrollTop = st;
        });
    }

    function GO_HeaderMenu() {
        var MobilePopupMenu = $('.go-mobile-popup-menu');

        /*
        MobilePopupMenu.find('li.menu-item-has-children ul').each(function () {
            $(this).prepend('<li class="menu-item-back"><span class="menu-item-back-label"><i class="icon-menu-arrow arrow-back"></i></span></li>');
        });

        MobilePopupMenu.on('click', 'li.menu-item-has-children > a', function (event) {
            if ($(window).width() <= 991){
                event.preventDefault();
                var current = $(this).closest('li');
                current.addClass('go-to-sub-menu');
            }
        });

        MobilePopupMenu.on('click', '.menu-item-back', function (event) {
            if ($(window).width() <= 991) {
                event.preventDefault();
                var current = $(this).closest('.go-to-sub-menu');
                current.removeClass('go-to-sub-menu');
            }
        });*/

        MobilePopupMenu.on('click', 'li.menu-item-has-children > a', function (event) {
            if ($(window).width() <= 991){
                event.preventDefault();
                var current = $(this).closest('li');
                current.toggleClass('go-to-sub-menu');
                current.children('ul').slideToggle("fast");
            }
        });

        $body.on('click', '#go-primary-menu-toggle', function (e) {
            e.preventDefault();
            var $this = $(this);

            if ($this.is('.open')) {
                $this.removeClass('open');
                $body.removeClass('visible-go-menu');
                slideBanner();
            } else {
                $this.addClass('open');
                $body.addClass('visible-go-menu');
                hideBanner();
            }
        });

        $("#mobile-menu-signin").on('click', function (event) {
            if ($(window).width() <= 991){
                event.preventDefault();
                var current = $(".menu-modules-wrapper .menu-module-sign_in");
                current.toggleClass('go-to-sub-menu');
                current.slideToggle("fast");
                $("#mobile-menu-signin").toggleClass('mobile-menu-arrow');
            }
        });

    }

    function setDownloadLink() {
        var btn = $('#h_download_now, .js--download-link');
        if (btn.length > 0 && __jsVars.download_links !== null) {
            var link = __jsVars.download_links.other;
            if (isMobile()) {
                for (var device in __jsVars.download_links) {
                    if (device != 'other' && isDevice(device)) {
                        link = __jsVars.download_links[device];
                    }
                }
            }

            btn.attr('href', link);
        }
    }

    function pricingElementEmpty() {
        $('.pricing_element').each(function() {
            if (jQuery.trim ($(this).text()) == '') $(this).addClass('pricing_element_is_empty');
        });
    }
    function pricingElementHighlight() {
        $('#pricing_element_data_highlight_style').remove();
        var highlightedElement = $('.pricing_element[data-highlight]');
        var parentHeight = highlightedElement.parent().height();
        highlightedElement.append('<style id="pricing_element_data_highlight_style">@media (min-width:768px) {.pricing-block-wrapper [data-highlight]::after { height: '+parentHeight +'px;}}</style>');
    }
    function supports_local_storage() {
        try {
            return 'localStorage' in window && window['localStorage'] !== null;
        } catch(e){
            return false;
        }
    }
    function setCookie(cookieName, cookieValue, nDays) {
        var today = new Date();
        var expire = new Date();
        if (nDays === null || nDays === 0) nDays = 1;
        expire.setTime(today.getTime() + 3600000 * 24 * nDays);
        document.cookie = cookieName + '=' + cookieValue + ';expires=' + expire.toGMTString() + '; path=/';
    }
    function readCookie(cookieName) {
        var re = new RegExp('[; ]' + cookieName + '=([^\\s;]+)');
        var sMatch = (' ' + document.cookie).match(re);
        if (cookieName && sMatch) return sMatch[1];
        return false;
    }
    isInfoBannerClosed = supports_local_storage() === true ? localStorage.getItem('info_banner_closed') : readCookie('info_banner_closed');
    isGeoStored = supports_local_storage() === true ? localStorage.getItem('mycountry') : readCookie('mycountry');
    var apiKey = __jsVars.info_banner.key;
    var country = __jsVars.info_banner.country_code;
    var useGeolocation = __jsVars.info_banner.use_geolocation;

    function loadBannerUsingGeolocation(results)
    {
        if (results === country) {
            showBanner();
        }
    }
    var infoBannerHeight;

    infoBannerHeight = $('.info_banner').outerHeight();
    function infoBannerHeightHelper() {
        if ($('.info_banner:visible').length == 0) {
            infoBannerHeight = 0;
        }
        $('.header-container + .content, .menu-modules-wrapper-inside').stop().animate({
            'padding-top': infoBannerHeight
        });
    }
    function showBanner() {
        isInfoBannerClosed = supports_local_storage() === true ? localStorage.getItem('info_banner_closed') : readCookie('info_banner_closed');
        if ( (isInfoBannerClosed === false) || (isInfoBannerClosed === null) || (isInfoBannerClosed.length < 1) ) {
            if( ( $('body.home').length > 0 ) ) {
                $('.info_banner').slideDown();
                infoBannerHeightHelper();
            } else {
                $('.info_banner').show(0);
                infoBannerHeightHelper();
            }
        } else {
            $('.info_banner').hide();
            $('.header-container + .content, .menu-modules-wrapper-inside').css('padding-top', '');
        }
    }
    function slideBanner() {
        isInfoBannerClosed = supports_local_storage() === true ? localStorage.getItem('info_banner_closed') : readCookie('info_banner_closed');
        if ( (isInfoBannerClosed === false) || (isInfoBannerClosed === null) || (isInfoBannerClosed.length < 1) ) {
            $('.info_banner').slideDown();
            infoBannerHeightHelper();
        } else {
            $('.info_banner').hide();
            $('.header-container + .content, .menu-modules-wrapper-inside').css('padding-top', '');
        }
    }
    function hideBanner() {
        $('.info_banner').slideUp();
        $('.header-container + .content, .menu-modules-wrapper-inside').animate({
            'padding-top': ''
        });
    }
    function displayCanvasBanner() {
            var canvasDiv = $('.s-top-banner-developers');
            canvasDiv.each(function() {
                var element = $(this)[0];
                var options = {
                    particleRadius: 1,
                    lineWidth: 1,
                    interactive: true,
                    speed: 'slow',
                    density: 'high',
                    background: '#3d94f5'
                };
                var particleCanvas = new ParticleNetwork(element, options);
            });
    }
    function hideTopBannerMenuTitleBr(){
        if( $(window).width() <= 768 ){
            $('.s-top-banner-menu .s-top-banner-menu-title').each(function(){
                if( !$(this).next('br').hasClass('break-line-mobile-only') ){
                    var topBannerMenuTitle = $(this).html(); 
                    if( topBannerMenuTitle.indexOf('<br> ') !== -1){  
                        topBannerMenuTitle = topBannerMenuTitle.replace("<br> ", "&nbsp;");       
                    }else if( topBannerMenuTitle.indexOf('<br/> ') !== -1){ 
                        topBannerMenuTitle = topBannerMenuTitle.replace("<br/> ", "&nbsp;");
                    }else if( topBannerMenuTitle.indexOf('<br /> ') !== -1){ 
                        topBannerMenuTitle = topBannerMenuTitle.replace("<br /> ", "&nbsp;");
                    }else if( topBannerMenuTitle.indexOf('<br>') !== -1){  
                        topBannerMenuTitle = topBannerMenuTitle.replace("<br>", "&nbsp;");       
                    }else if( topBannerMenuTitle.indexOf('<br/>') !== -1){ 
                        topBannerMenuTitle = topBannerMenuTitle.replace("<br/>", "&nbsp;");
                    }else if( topBannerMenuTitle.indexOf('<br />') !== -1){ 
                        topBannerMenuTitle = topBannerMenuTitle.replace("<br />", "&nbsp;");
                    }  
                    $(this).html(topBannerMenuTitle); 
                }
            });
        }
    }

    $(document.body).on('click', '.info_banner__close', function() {
        $(this).closest('.info_banner').slideUp();
        $('.header-container + .content, .menu-modules-wrapper-inside').animate({
            'padding-top': ''
        });
        supports_local_storage() === true ? localStorage.setItem('info_banner_closed', true) : setCookie('info_banner_closed', true, 732);
    });


    // Accesories filters & load more
    var $catItems = $('.products-items'),
        term_id = new Array(typeof $catItems.attr('data-term_id') != "undefined" && $catItems.attr('data-term_id') != '' ? $catItems.attr('data-term_id') : '');

    $('.catalog').ikDynamicLoadService({
        url: __jsVars.url.ajax,
        method: "GET",
        loadMoreButton: "#btn_load_more",
        setFilterAttr: 'data-set-filter',
        updateBoxClass: '.products-items',
        ajaxDefaultData: {
            action: 'ic_accessories_load',
            paged: 1,
            filters: {
                platform: [],
                device: [],
                category: term_id
            }
        }
    });

    // Customers/press/Content load more
    var $btnLoadMore = $("#btn_load_more_posts");
    $('.s-posts-lists').ikDynamicLoadService({
        url: __jsVars.url.ajax,
        method: "GET",
        loadMoreButton: "#btn_load_more_posts",
        updateBoxClass: '.sp-lists',
        ajaxDefaultData: {
            action: 'ic_load_posts',
            post_type: $btnLoadMore.attr('data-post-type'),
            posts_per_page: parseInt($btnLoadMore.attr('data-posts_per_page')),
            paged: 1
        }
    });

    /** Sing in console form redirect to subdomain */
    $body.on('submit', 'form.form-sign-in-console', function (e) {
        e.preventDefault();
        var $input = $(this).find('input.input-sign-in-console');
        if ($input.val().trim() != '') {
            window.location.href = 'https://' + $input.val().trim() + $input.attr('data-end');
            $(this).find('button[type="submit"]').addClass('btn-preloader btn-blue-loader');
            $(this).find('button[type="submit"]').prepend(env.ajaxPreloader);
        }
    });
    /** Sing in console form redirect to login pahe of zello.com */
    $body.on('submit', 'form.form-sign-in-account', function (e) {
        e.preventDefault();
        window.location.href = $(this).attr('action');
        $(this).find('button[type="submit"]').addClass('btn-preloader');
        $(this).find('button[type="submit"]').prepend(env.ajaxPreloader);
    });

    setDownloadLink();
    headerMenu();
    GO_HeaderMenu();
    footerMask();
    footerTogglemobileMenu();
    initLightBox();
    postsListToggle();
    pricingElementEmpty();
    pricingElementHighlight();
    displayCanvasBanner();
    hideTopBannerMenuTitleBr();

    var pageAccount = $('.zello-page-connection');
    if (pageAccount.length > 0 && typeof pageAccount.attr('data-action') !== 'undefined') {
        new zelloAccountConnection('.zello-page-connection', {
            action: pageAccount.attr('data-action')
        });
    }
    if (useGeolocation) {
        jQuery(window).geolocate(country, apiKey, loadBannerUsingGeolocation);
    } else {
        showBanner();
    }

    if ($body.is('.error404, .page-template-page-404')) {
        lineDraw();
    }

    $(window).on('load', function () {
        footerMask();
    });
    $(window).on('resize', function () {
        footerMask();
        pricingElementHighlight();
        infoBannerHeight = $('.info_banner').outerHeight();
        infoBannerHeightHelper();
    });

    if ($(window).width() < 767 && is_touch_device()) {
        $body.addClass('touch-screen');
    }

    $(".js--show-law-submission-form input").on('change',function() {
        if(this.checked) {
            var submissionFormUrl = $(this).parent().data('submission-form-url');
            $('.law-submission-form-link').show();
            $('.law-submission-form-link a').attr('href', submissionFormUrl+'?authorized-request=yes');
        }else{
            $('.law-submission-form-link').hide();
            $('.law-submission-form-link a').attr('href', '');
        }
    });
    $('.js--government-agency').on('change',function() {
        if( $(this).val()==='Other' ){
            $('.government-agency-other').show();
        }else{
            $('.government-agency-other').hide();
        }
    });
    $('.js--nature-of-emergency').on('change',function() {
        if( $(this).val()==='Other' ){
            $('.nature-of-emergency-other').show();
        }else{
            $('.nature-of-emergency-other').hide();
        }
    });
    $('.js--immediate-danger').on('change',function() {
        if( $(this).val()==='Yes' ){
            $('.immediate-danger-section').show();
        }else{
            $('.immediate-danger-section').hide();
        }
    });

    $(document).ready(function(){
        //unbounceLp();
        $('#law-submission-form').validate({
            errorPlacement: function(error, element) {
                if (element.attr('name') == 'immediate-danger' ) {
                    error.insertAfter('#immediate-danger-head');
                } else {
                    error.insertAfter(element);
                }
            },            
            showErrors: function(errorMap, errorList) {
                var errors = this.numberOfInvalids();
                if (errors) {
                    var message = errors == 1
                    ? 'Please complete one missed field. It has been highlighted.'
                    : 'Please complete ' + errors + ' missed fields. They have been highlighted.';
                    $('.errors-message-section .errors').html(message);
                    $('.errors-message-section').show();
                    this.defaultShowErrors();
                } else {
                    $('.errors-message-section').hide();
                }
            },        
            submitHandler: function(form) {
                var formData = new FormData(form);
                var fileInput1 = document.getElementById('required-information-file');
                var file1 = fileInput1.files[0];
                var fileInput2 = document.getElementById('required-information-file');
                var file2 = fileInput2.files[0];
                formData.append('required-information-file', file1); 
                formData.append('subpoena-search-warrant-file', file2); 
                console.log(formData);
                $('.law-submission-form-wrapper').hide();
                $('.form-complete-message').show();
                /*$.ajax({
                    url: "/abreajax.php", 
                    type: "POST",             
                    data: formData,
                    contentType: false,       
                    cache: false,             
                    processData:false, 
                    success: function(data){
                        $('#law-submission-form').hide();
                        $('.form-complete-message').show();
                        $('.form-complete-message').append(data);
                    }
                });*/
            }
        });
       // $(window).on('resize', unbounceLp);
        
    });

    $("#menu-bottom-social li a").attr("target","_blank");

})(jQuery);